import React, { useEffect, useState } from "react";
import withRouter from "../Components/Common/withRouter";
import { useSelector } from "react-redux";
import { PublicMenuContext } from "../context/publicMenu";
import PublicBottomNav from "../Public/components/navbar/PublicBottomNav/PublicBottomNav";
import "../Public/publicPremium.scss";

const NonAuthLayout = ({ children }) => {
  const { layoutModeType } = useSelector((state) => ({
    layoutModeType: state.Layout.layoutModeType,
  }));
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    // Panel CSS/body kalıntısı çıkış sonrası auth sayfasını bozmasın
    document.body.classList.remove(
      "kuzem-panel",
      "kuzem-product",
      "kuzem-atlas",
      "vertical-sidebar-enable",
      "twocolumn-panel",
      "menu"
    );
    // Alt navbar aktifken içerik/footer'a nefes payı bırakmak için (bkz. PublicBottomNav.scss)
    document.body.classList.add("public-bottom-nav-active");

    if (layoutModeType === "dark") {
      document.body.setAttribute("data-layout-mode", "dark");
    } else {
      document.body.setAttribute("data-layout-mode", "light");
    }
    return () => {
      document.body.removeAttribute("data-layout-mode");
      document.body.classList.remove("public-bottom-nav-active");
    };
  }, [layoutModeType]);

  return (
    <PublicMenuContext.Provider value={{ toggle, setToggle }}>
      <div className="public-site">
        {children}
        <PublicBottomNav />
      </div>
    </PublicMenuContext.Provider>
  );
};

export default withRouter(NonAuthLayout);
